<div class="error-toast" (click)="jumpToCategory()">
  <div class="error-icon-container">
    <span class="error-icon"><mat-icon svgIcon="alert-triangle"></mat-icon></span>
  </div>
  <div class="error-message-container">
    <span class="error-message">{{ message }}</span>
  </div>
</div>
